import React from 'react';
import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';
import LabelCard from '../../../../components/label-card';
import MultiPackageBadge from '../../../../components/multi-package-badge';
import MultiPackageList from '../../../../components/multi-package-list';
import ShipmentDetails from '../../../../components/shipment-details';
import { ReturnShipmentPropType } from '../../../../prop-types/return-shipment';
import { FulfillmentPlanOrderGridStatus } from '../../../../enums/fulfillmentplan-order-grid-status';
import { ShipmentHelperService } from '../../../../services/shipment-helper-service';

import style from './return-details-modal-content.module.less';

const renderMultiPackageCount = (props) => {
  const packages = get(props, 'returnShipment.returnConfiguration.packages', emptyArray);
  if (packages.length <= 1) {
    return null;
  }
  return (
    <div className={style['multi-package-wrapper']}>
      <MultiPackageBadge packageCount={packages.length} />
    </div>
  );
};

const renderMultiPackageList = (props) => {
  const packages = get(props, 'returnShipment.returnConfiguration.packages', emptyArray);
  if (packages.length <= 1) {
    return null;
  }
  return <MultiPackageList packages={packages} />;
};

export const ActiveReturnLabel = (props) => {
  const orderGridStatus = FulfillmentPlanOrderGridStatus.Shipped.name;
  const carrierId = get(props, 'returnShipment.returnConfiguration.carrierId');
  const serviceId = get(props, 'returnShipment.returnConfiguration.serviceId');
  const trackingInformation = get(props, 'returnShipment.trackingInformation');
  const totalCost = ShipmentHelperService.getTotalCost(props.returnShipment);
  const labelCardProps = {
    carrierId,
    serviceId,
    trackingInformation,
    orderGridStatus,
    totalCost,
  };

  return (
    <div>
      <div className={style['active-label']}>
        <LabelCard {...labelCardProps} />
        {renderMultiPackageCount(props)}
        <ShipmentDetails {...props} />
      </div>
      {renderMultiPackageList(props)}
    </div>
  );
};

ActiveReturnLabel.propTypes = {
  returnShipment: ReturnShipmentPropType.isRequired,
};
